import React from 'react';
import clsx from 'clsx';
import { Calendar } from 'lucide-react';
import { formatMediumDate } from '@utils/dateUtils';
import styles from './DateCell.module.css';

export interface DateCellProps {
  date: string | null | undefined;
  formatDate?: (dateString: string | null | undefined) => string;
  className?: string;
}

const DateCell: React.FC<DateCellProps> = ({ date, formatDate, className }) => {
  const defaultFormatDate = (dateString: string | null | undefined) =>
    formatMediumDate(dateString, 'Not scheduled');

  const formattedDate = formatDate ? formatDate(date) : defaultFormatDate(date);

  return (
    <div className={clsx(styles.dateCell, className)}>
      <div className={styles.dateInfo}>
        <Calendar size={14} />
        {formattedDate}
      </div>
    </div>
  );
};

export default DateCell;
